import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const PricingPage = () => {
  useEffect(() => {
    // SEO Meta Tags
    document.title = '가격 안내 - 유흥디자인랩 | 구인광고 5만원 홈페이지 10만원';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '유흥디자인랩의 합리적인 가격 안내. 구인광고 디자인 5만원부터, 홈페이지 제작 10만원부터. 특별 한정 이벤트 가격 적용 중. 투명하고 합리적인 가격 정책으로 전문 디자인 서비스를 제공합니다.');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "PriceSpecification",
      "name": "유흥디자인랩 가격표",
      "description": "구인광고 및 홈페이지 제작 서비스 가격",
      "priceCurrency": "KRW",
      "offers": [
        {
          "@type": "Offer",
          "name": "구인광고 디자인",
          "price": "50000",
          "priceCurrency": "KRW",
          "description": "박스/실장/가게 구인 전용 광고페이지 제작",
          "itemOffered": {
            "@type": "Service",
            "name": "구인광고 디자인",
            "provider": {
              "@type": "ProfessionalService",
              "name": "유흥디자인랩"
            }
          }
        },
        {
          "@type": "Offer",
          "name": "홈페이지 제작",
          "price": "100000",
          "priceCurrency": "KRW",
          "description": "업체 홍보·모객 전용 웹사이트",
          "itemOffered": {
            "@type": "Service",
            "name": "홈페이지 제작",
            "provider": {
              "@type": "ProfessionalService",
              "name": "유흥디자인랩"
            }
          }
        }
      ]
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <div className="inline-block bg-neon-pink text-white px-4 py-1.5 rounded text-xs font-bold uppercase mb-4">
                PRICING
              </div>
              <h1 className="text-5xl md:text-6xl font-black text-navy leading-tight mb-6">
                합리적인 가격으로<br />
                전문 디자인을 경험하세요
              </h1>
              <p className="text-gray-600 text-lg">
                특별 한정 이벤트 가격 적용 중
              </p>
            </div>
          </div>
        </section>

        {/* Pricing Cards */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-20">
              {/* 구인광고 */}
              <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-gray-100 hover:border-neon-pink transition-all hover:shadow-2xl">
                <div className="bg-neon-light p-8 flex items-center justify-center">
                  <img
                    src="https://public.readdy.ai/ai/img_res/fcca88b268750b571e8f6636a31f2f1e.jpg"
                    alt="구인광고 디자인"
                    className="w-full h-48 object-contain"
                  />
                </div>
                <div className="p-8 text-center">
                  <h3 className="text-xl font-bold text-navy mb-4">
                    구인광고 디자인
                  </h3>
                  <div className="mb-8">
                    <div className="flex items-baseline gap-2 mb-2">
                      <span className="text-5xl font-black text-neon-pink">5만원</span>
                      <span className="text-gray-500 text-lg">부터</span>
                    </div>
                    <p className="text-sm text-gray-600">박스/실장/가게 구인 전용</p>
                  </div>
                  <div className="space-y-4 mb-6">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-line text-neon-pink text-xl mt-0.5"></i>
                      <div>
                        <p className="font-semibold text-navy">반응형 디자인</p>
                        <p className="text-sm text-gray-600">모바일/PC 최적화</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-check-line text-neon-pink text-xl mt-0.5"></i>
                      <div>
                        <p className="font-semibold text-navy">기본 수정 1회</p>
                        <p className="text-sm text-gray-600">디자인 피드백 반영</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-check-line text-neon-pink text-xl mt-0.5"></i>
                      <div>
                        <p className="font-semibold text-navy">빠른 제작</p>
                        <p className="text-sm text-gray-600">2-3일 내 완성</p>
                      </div>
                    </div>
                  </div>
                  <div className="border-t pt-6">
                    <p className="text-sm text-gray-600 mb-2">추가 옵션:</p>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li>• 추가 수정: 회당 10,000원</li>
                      <li>• 프리미엄 이미지: 협의</li>
                      <li>• 영상 콘텐츠: 협의</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 홈페이지 */}
              <div className="bg-gradient-to-br from-neon-pink to-pink-600 rounded-3xl p-8 shadow-xl relative overflow-hidden hover:shadow-2xl transition-all">
                <div className="bg-blue-50 p-8 flex items-center justify-center">
                  <img
                    src="https://readdy.ai/api/search-image?query=elegant%20modern%20business%20website%20homepage%20mockup%20design%20with%20sophisticated%20layout%20showing%20promotional%20content%20and%20brand%20image%20in%20professional%20style%20with%20clean%20interface%20perfect%20for%20nightlife%20venue%20marketing%20with%20premium%20aesthetic&width=400&height=300&seq=website-mockup&orientation=landscape"
                    alt="홈페이지 제작"
                    className="w-full h-48 object-contain"
                  />
                </div>
                <div className="p-8 text-center">
                  <h3 className="text-xl font-bold text-navy mb-4">
                    홈페이지 제작 기본
                  </h3>
                  <div className="mb-8">
                    <div className="flex items-baseline gap-2 mb-2">
                      <span className="text-5xl font-black text-white">10만원</span>
                      <span className="text-white/80 text-lg">부터</span>
                    </div>
                    <p className="text-sm text-gray-600">업체 홍보·모객 전용</p>
                  </div>
                  <div className="space-y-4 mb-6">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-line text-navy text-xl mt-0.5"></i>
                      <div>
                        <p className="font-semibold text-navy">맞춤형 디자인</p>
                        <p className="text-sm text-gray-600">업체 특성 반영</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-check-line text-navy text-xl mt-0.5"></i>
                      <div>
                        <p className="font-semibold text-navy">반응형 웹</p>
                        <p className="text-sm text-gray-600">모든 기기 최적화</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-check-line text-navy text-xl mt-0.5"></i>
                      <div>
                        <p className="font-semibold text-navy">기본 수정 1회</p>
                        <p className="text-sm text-gray-600">완성도 높은 결과물</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-check-line text-navy text-xl mt-0.5"></i>
                      <div>
                        <p className="font-semibold text-navy">SEO 최적화</p>
                        <p className="text-sm text-gray-600">검색 노출 향상</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-check-line text-navy text-xl mt-0.5"></i>
                      <div>
                        <p className="font-semibold text-navy">문의 폼 연동</p>
                        <p className="text-sm text-gray-600">고객 문의 관리</p>
                      </div>
                    </div>
                  </div>
                  <div className="border-t pt-6">
                    <p className="text-sm text-gray-600 mb-2">추가 옵션:</p>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li>• 추가 페이지: 페이지당 30,000원</li>
                      <li>• 예약 시스템: 협의</li>
                      <li>• 회원 관리: 협의</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Detailed Pricing Breakdown */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-black text-navy mb-4">
                상세 가격 안내
              </h2>
              <p className="text-gray-600 text-lg">
                투명하고 합리적인 가격 정책
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* 구인광고 상세 */}
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-neon-light rounded-xl">
                    <i className="ri-user-search-line text-neon-pink text-2xl"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-navy">구인광고 디자인</h3>
                </div>
                
                <div className="mb-6">
                  <div className="flex items-baseline gap-2 mb-2">
                    <span className="text-4xl font-black text-neon-pink">50,000원</span>
                    <span className="text-gray-500">기본</span>
                  </div>
                  <p className="text-sm text-gray-600">박스/실장/가게 구인 전용</p>
                </div>

                <div className="space-y-4 mb-6">
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-neon-pink text-xl mt-0.5"></i>
                    <div>
                      <p className="font-semibold text-navy">반응형 디자인</p>
                      <p className="text-sm text-gray-600">모바일/PC 최적화</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-neon-pink text-xl mt-0.5"></i>
                    <div>
                      <p className="font-semibold text-navy">기본 수정 1회</p>
                      <p className="text-sm text-gray-600">디자인 피드백 반영</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-neon-pink text-xl mt-0.5"></i>
                    <div>
                      <p className="font-semibold text-navy">빠른 제작</p>
                      <p className="text-sm text-gray-600">2-3일 내 완성</p>
                    </div>
                  </div>
                </div>

                <div className="border-t pt-6">
                  <p className="text-sm text-gray-600 mb-2">추가 옵션:</p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li>• 추가 수정: 회당 10,000원</li>
                    <li>• 프리미엄 이미지: 협의</li>
                    <li>• 영상 콘텐츠: 협의</li>
                  </ul>
                </div>
              </div>

              {/* 홈페이지 상세 */}
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-50 rounded-xl">
                    <i className="ri-global-line text-navy text-2xl"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-navy">홈페이지 제작</h3>
                </div>
                
                <div className="mb-6">
                  <div className="flex items-baseline gap-2 mb-2">
                    <span className="text-4xl font-black text-navy">100,000원</span>
                    <span className="text-gray-500">기본</span>
                  </div>
                  <p className="text-sm text-gray-600">업체 홍보·모객 전용</p>
                </div>

                <div className="space-y-4 mb-6">
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-navy text-xl mt-0.5"></i>
                    <div>
                      <p className="font-semibold text-navy">맞춤형 디자인</p>
                      <p className="text-sm text-gray-600">업체 특성 반영</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-navy text-xl mt-0.5"></i>
                    <div>
                      <p className="font-semibold text-navy">반응형 웹</p>
                      <p className="text-sm text-gray-600">모든 기기 최적화</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-navy text-xl mt-0.5"></i>
                    <div>
                      <p className="font-semibold text-navy">기본 수정 1회</p>
                      <p className="text-sm text-gray-600">완성도 높은 결과물</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-navy text-xl mt-0.5"></i>
                    <div>
                      <p className="font-semibold text-navy">SEO 최적화</p>
                      <p className="text-sm text-gray-600">검색 노출 향상</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-navy text-xl mt-0.5"></i>
                    <div>
                      <p className="font-semibold text-navy">문의 폼 연동</p>
                      <p className="text-sm text-gray-600">고객 문의 관리</p>
                    </div>
                  </div>
                </div>

                <div className="border-t pt-6">
                  <p className="text-sm text-gray-600 mb-2">추가 옵션:</p>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li>• 추가 페이지: 페이지당 30,000원</li>
                    <li>• 예약 시스템: 협의</li>
                    <li>• 회원 관리: 협의</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-black text-navy mb-4">
                자주 묻는 질문
              </h2>
            </div>

            <div className="space-y-6">
              <div className="bg-gray-50 rounded-2xl p-8">
                <h3 className="text-lg font-bold text-navy mb-3">
                  제작 기간은 얼마나 걸리나요?
                </h3>
                <p className="text-gray-600">
                  구인광고는 2-3일, 홈페이지는 5-7일 정도 소요됩니다. 프로젝트 규모에 따라 달라질 수 있습니다.
                </p>
              </div>

              <div className="bg-gray-50 rounded-2xl p-8">
                <h3 className="text-lg font-bold text-navy mb-3">
                  수정은 몇 번까지 가능한가요?
                </h3>
                <p className="text-gray-600">
                  기본 1회 수정이 포함되어 있으며, 추가 수정은 회당 10,000원입니다.
                </p>
              </div>

              <div className="bg-gray-50 rounded-2xl p-8">
                <h3 className="text-lg font-bold text-navy mb-3">
                  호스팅은 어떻게 되나요?
                </h3>
                <p className="text-gray-600">
                  1년 호스팅이 제공되며, 이후 연간 10만원 유지보수 비용이 발생합니다.
                </p>
              </div>

              <div className="bg-gray-50 rounded-2xl p-8">
                <h3 className="text-lg font-bold text-navy mb-3">
                  결제는 어떻게 하나요?
                </h3>
                <p className="text-gray-600">
                  결제는 모두 선결제로 이루어지고 있습니다.
                </p>
              </div>

              <div className="bg-gray-50 rounded-2xl p-8">
                <h3 className="text-lg font-bold text-navy mb-3">
                  환불 정책은 어떻게 되나요?
                </h3>
                <p className="text-gray-600">
                  작업 시작 전 100% 환불, 시안 제공 후에는 환불이 불가합니다.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-neon-pink">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
              지금 바로 시작하세요
            </h2>
            <p className="text-white/90 text-lg mb-8">
              이벤트 특가는 한정 수량으로 진행됩니다.<br />
              지금 신청하고 특별한 혜택을 받아보세요.
            </p>
            <button
              onClick={scrollToContact}
              className="bg-white text-neon-pink px-10 py-5 rounded-full font-bold text-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
            >
              무료 상담 신청하기
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PricingPage;